const anchors = document.querySelectorAll(".coa-links-container a");
const modal = document.getElementById("coa-modal");
const closeModalBtn = document.getElementById("coa-modal-close-btn");
const openPdfCTA = document.getElementById("open-pdf-CTA");
const iframe = document.getElementById("lab-report-pdf-iframe");

if (anchors.length > 0) {
  anchors.forEach((anchor) => {
    if (anchor && anchor.href && anchor.href.match(/\.pdf(\?.*)?$/i)) {
      const button = document.createElement("button");
      button.innerHTML = anchor.innerHTML;
      button.classList.add("coa-link");
      button.setAttribute("aria-haspopup", "dialog");
      button.setAttribute("data-target", "coa-modal");
      button.addEventListener("click", () => openModal(anchor.href));

      anchor.replaceWith(button);
    }
  });
}

function openModal(url) {
  modal.classList.toggle("visible");
  document.body.classList.add("modal-open");
  iframe.src = url;
  openPdfCTA.href = url;
}

function closeModal() {
  modal.classList.toggle("visible");
  document.body.classList.remove("modal-open");
  iframe.src = "";
}

closeModalBtn.addEventListener("click", closeModal);

// Close the modal when clicking outside the modal content
window.addEventListener("click", function (event) {
  if (event.target === modal) {
    closeModal();
  }
});
